import React from "react";
import {useSelector} from "react-redux";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";
import Widget from "../../prefabricated/Widget";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Row, Col } from 'reactstrap'
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";


const TilePortfolioFidelity = (props) => {

    const { entityId , title} = props;

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const { portfolios} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const entity = bbFindEntityWithinPortfolioOrSelf(entityId, portfolios, customerInView);
    const lastCycle = entity ? entity.last_cycle : null

    const companyName = entity.name;

    return(
        <>
            <Widget styleName={`pl-3 pr-2 bg-light animated fadeIn animation-duration-5 dataTile`}>
                <Tooltip heading={"Fidelity"} link={`/board/userguide`} width={"200px"}>
                    <InfoSharpIcon style={{fontSize: "20px",  marginTop: -25, zIndex:5}} className={`text-muted float-right`}/>
                </Tooltip>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h1>{title}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BRFidelityBadge cycleObject={lastCycle}/>
                            <h2 className={`text-muted mb-2 bb-font-fridge-bold text-center`}>
                                {companyName}
                            </h2>
                        </Col>
                    </Row>
                </div>

            </Widget>
        </>

    )
}

export default TilePortfolioFidelity
